interface CityAndCode {
  city: string;
  code: string;
}

/**
 * Parses a string containing a city name and airport code in the format "City (CODE)"
 * into an object with separate city and code properties.
 *
 * @param {string | null | undefined} value - The input string to parse, e.g. "Antofagasta (ANF)"
 * @returns {{city: string, code: string}} An object with `city` and `code` properties
 * @example
 * // returns { city: 'Antofagasta', code: 'ANF' }
 * parseCityAndCode('Antofagasta (ANF)');
 *
 * @example
 * // returns { city: 'Santiago', code: '' }
 * parseCityAndCode('Santiago');
 *
 * @example
 * // returns { city: '', code: '' }
 * parseCityAndCode(null);
 */
export default function parseCityAndCode(value: string | null | undefined): CityAndCode {
  const str = (value || "").trim();
  const re = /^(.*)\s*\(([^)]+)\)$/;
  const match = re.exec(str);

  if (match) {
    const [, rawCity = "", rawCode = ""] = match;
    return { city: rawCity.trim(), code: rawCode.trim() };
  }

  return { city: str, code: "" };
}
